import React from "react"
import { Box, Flex, Divider, Heading } from "rebass"
import styled from "styled-components"

import colors from "../../config/colors.js"

const StyledHeader = styled(Heading)`
  display: inline-block;
  font-size: 22px;
  text-align: center;
  &:after {
    content: '';
    width: 66%;
    margin: 0 auto;
    height: 2px;
    background-color: ${colors.yellow};
    display: block;
  }
`

const SectionHeader = ({ title, color }) => (
  <Flex justifyContent="center">
    <div>
      <StyledHeader color={color}>{title}</StyledHeader>
    </div>
  </Flex>
)

export default SectionHeader



// WEBPACK FOOTER //
// ./src/components/SectionHeader/index.js